import * as R from 'ramda';
import React from 'react';
import NicknameIcon from '../components/NicknameIcon';

const navigationList: NavigationItem[] = [
  {
    id: 'dict',
    icon: 'Journal',
    label: 'Dictionaries',
    active: false,
    link: '/dictionaries',
    scopes: ['search360:dictionary:read', 'search360:dictionary:write'],
    subItems: [
      {
        id: 'dict-a',
        label: 'Nike Custom',
        active: false,
        link: '/dictionaries/nike-custom',
      },
      {
        id: 'dict-b',
        label: 'Stop Words',
        active: false,
        link: '/dictionaries/stop-words',
      },
      {
        id: 'dict-c',
        label: 'NOGO',
        active: false,
        link: '/dictionaries/no-go',
      },
    ],
  },
  {
    id: 'rewrite',
    icon: 'Edit',
    label: 'Rewrite',
    active: false,
    link: '/rewrite/list',
    scopes: ['search360:rewrite:read', 'search360:rewrite:write'],
  },
  {
    id: 'recommend-concepts',
    icon: 'Report',
    label: 'Recommend Concepts',
    active: false,
    link: '/recommend-concepts',
    scopes: ['search360:concept:read', 'search360:concept:write'],
  },
  {
    id: 'playground',
    icon: 'Discover',
    label: 'Playground',
    active: false,
    link: '/playground',
    subItems: [
      {
        id: 'playground-a',
        label: 'Tokenization',
        active: false,
        link: '/playground/tokenizer',
      },
      {
        id: 'playground-b',
        label: 'Product Wall',
        active: false,
        link: '/playground/product-wall',
      },
      {
        id: 'playground-c',
        label: 'New Product Wall',
        active: false,
        link: '/playground/new-product-wall',
      },
    ],
  },
  // {
  //   id: 'labelling',
  //   icon: 'Programs',
  //   label: 'Labelling',
  //   active: false,
  //   link: '/labelling/datasets',
  //   scopes: ['search360:labeling:read', 'search360:labeling:write'],
  //   subItems: [
  //     {
  //       id: 'labelling-a',
  //       label: 'Datasets',
  //       active: false,
  //       link: '/labelling/datasets',
  //     },
  //   ],
  // },
  {
    id: 'nickname',
    icon: React.createElement(NicknameIcon),
    label: 'Nickname',
    active: false,
    link: '/nickname/dictionary',
    scopes: ['search360:nickname:read', 'search360:nickname:write'],
    subItems: [
      {
        id: 'nickname-a',
        label: 'Product List',
        active: false,
        link: '/nickname/list',
      },
      {
        id: 'nickname-b',
        label: 'Index',
        active: false,
        link: '/nickname/dictionary',
      },
    ],
  },
  {
    id: 'hotsearch',
    icon: 'Burn',
    label: 'Hotsearch',
    active: false,
    link: '/hotsearch/ranking-lists',
    // search360:hotsearch:create
    // search360:hotsearch:meta-update
    // search360:hotsearch:content-update
    // search360:hotsearch:delete
    // search360:hotsearch:publish
    scopes: [
      'search360:hotsearch:read',
      'search360:hotsearch:create',
      'search360:hotsearch:meta-update',
      'search360:hotsearch:delete',
      'search360:hotsearch:publish',
      'search360:hotsearch:content-update',
    ],
    subItems: [
      {
        id: 'hotsearch-a',
        label: 'Ranking Lists',
        active: false,
        link: '/hotsearch/ranking-lists',
      },
    ],
  },
  {
    id: 'ranking',
    icon: 'Sort',
    label: 'Ranking',
    active: false,
    link: '/ranking',
    scopes: ['search360:ranking:read', 'search360:ranking:write'],
    subItems: [
      {
        id: 'ranking-a',
        label: 'Ranking Rule List',
        active: false,
        link: '/ranking',
      },
      {
        id: 'ranking-b',
        label: 'Create New Rule',
        active: false,
        link: '/ranking/create-rule',
      },
    ],
  },
  {
    id: 'user-management',
    icon: 'Club',
    label: 'User Management',
    active: false,
    link: '/identity',
    scopes: ['search360:identity:read', 'search360:identity:write'],
    subItems: [
      {
        id: 'user-list',
        label: 'User List',
        active: false,
        link: '/identity/users',
      },
      {
        id: 'role-list',
        label: 'Role List',
        active: false,
        link: '/identity/roles',
      },
      {
        id: 'audit-list',
        label: 'Audit Log',
        active: false,
        link: '/identity/audit',
      },
    ],
  },
  {
    id: 'searchops',
    icon: 'Settings',
    label: 'Search Ops',
    active: false,
    link: '/searchops/indexes',
    scopes: ['search360:searchops:read', 'search360:searchops:write'],
    subItems: [
      {
        id: 'searchops-indexes',
        label: 'Indexes',
        active: false,
        link: '/searchops/indexes',
      },
      {
        id: 'searchops-query-console',
        label: 'Query Console',
        active: false,
        link: '/searchops/query-console',
      },
      {
        id: 'searchops-force-update',
        label: 'Force Update',
        active: false,
        link: '/searchops/force-update',
      },
    ],
  },
  {
    id: 'release-log',
    icon: 'History',
    label: 'Release Log',
    active: false,
    link: '/release-log',
    scopes: [],
  },
];
const setActiveNavItemsByCurrentUrlPath = (
  items: NavigationItem[],
  currentUrlPath: string,
) => {
  for (const nav of items) {
    if (nav.link === currentUrlPath) {
      nav.active = true;
    } else if (nav.active) {
      nav.active = false;
    }
    if (nav.subItems) {
      setActiveNavItemsByCurrentUrlPath(nav.subItems, currentUrlPath);
    }
  }
};

const _getNavBreadcrumbsByCurrentUrlPath = (
  items: NavigationItem[],
  currentUrlPath: string,
  result: NavigationItem[],
) => {
  for (const nav of items) {
    if (currentUrlPath.startsWith(nav.link)) {
      result.push(R.pick(['id', 'label', 'link', 'active'], nav));
      if (nav.subItems) {
        _getNavBreadcrumbsByCurrentUrlPath(
          nav.subItems,
          currentUrlPath,
          result,
        );
      }
    }
  }
};
const getNavBreadcrumbsByCurrentUrlPath = (
  items: NavigationItem[],
  currentUrlPath: string,
) => {
  const breadcrumbs: NavigationItem[] = [];
  _getNavBreadcrumbsByCurrentUrlPath(items, currentUrlPath, breadcrumbs);
  return breadcrumbs;
};

export {
  navigationList,
  setActiveNavItemsByCurrentUrlPath,
  getNavBreadcrumbsByCurrentUrlPath,
};
